import { Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "@/pages/Login";
import { RestablecerPasswordPage } from "@/pages/RestablecerPassword";
import { ExpedienteDetailPage } from "@/pages/ExpedienteDetail";
import { ChatIntakePage } from "@/pages/ChatIntake";
import { PendientesCrmPage } from "@/pages/PendientesCrm";
import { PqrCrmDetallePage } from "@/pages/PqrCrmDetalle";
import { KpisPage } from "@/pages/Kpis";
import { UsuariosPage } from "@/pages/Usuarios";
import { EmpresasPage } from "@/pages/Empresas";
import { RequiereAuth } from "@/components/RequiereAuth";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Restablecer contraseña vía enlace del correo — ruta pública. */}
      <Route path="/restablecer" element={<RestablecerPasswordPage />} />
      {/* Home: pestaña Pendientes CRM . Con auto-ingesta los
          casos entran y se procesan solos; el operador trabaja aquí. */}
      <Route
        path="/"
        element={
          <RequiereAuth>
            <PendientesCrmPage />
          </RequiereAuth>
        }
      />
      {/* /expedientes redirige a / (Bandeja unificada — ). */}
      <Route
        path="/expedientes"
        element={<Navigate to="/" replace />}
      />
      <Route
        path="/expedientes/nuevo"
        element={
          <RequiereAuth>
            <ChatIntakePage />
          </RequiereAuth>
        }
      />
      <Route
        path="/expedientes/:id"
        element={
          <RequiereAuth>
            <ExpedienteDetailPage />
          </RequiereAuth>
        }
      />
      {/* KPIs operacionales (Fase B.5). */}
      <Route
        path="/kpis"
        element={
          <RequiereAuth>
            <KpisPage />
          </RequiereAuth>
        }
      />
      {/* Administración de usuarios — sólo administradores. */}
      <Route
        path="/usuarios"
        element={
          <RequiereAuth rol="administrador">
            <UsuariosPage />
          </RequiereAuth>
        }
      />
      <Route
        path="/empresas"
        element={
          <RequiereAuth rol="administrador">
            <EmpresasPage />
          </RequiereAuth>
        }
      />
      {/* Alias: /pqr/crm sigue funcionando para bookmarks existentes. */}
      <Route
        path="/pqr/crm"
        element={
          <RequiereAuth>
            <PendientesCrmPage />
          </RequiereAuth>
        }
      />
      <Route
        path="/pqr/crm/:rad_open"
        element={
          <RequiereAuth>
            <PqrCrmDetallePage />
          </RequiereAuth>
        }
      />
    </Routes>
  );
}
